import Spinner from 'react-bootstrap/Spinner';

function AppSpinner({ label = 'Carregando...' }) {
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <Spinner animation="border" style={{ color: 'var(--color-purple-primary)' }} role="status">
        <span className="visually-hidden">{label}</span>
      </Spinner>
    </div>
  );
}

export default AppSpinner;
